import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from './privacy';

export const Route = createFileRoute('/terms')({ component: TermsPage });

export function TermsPage() {
  return (
    <LegalPage title="Terms of Service" path="/terms" screen="Terms Screen">
      <p>
        Hmonglus provides language-learning content for personal and educational use. Keep your
        account secure and use the service lawfully.
      </p>
      <p>
        Premium subscriptions renew through the store where they were purchased until canceled.
        Features and content may evolve over time.
      </p>
      <p>These terms do not replace the applicable Apple, Google, Stripe, or RevenueCat platform terms.</p>
    </LegalPage>
  );
}
